import Step from 'components/atoms/Step/BasicStep';

export { Step };
export default Step;
